<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 no-gutters">
    <form [formGroup]="iSupplierForm" class="col-xl-9 col-md-9 col-sm-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application Description</strong></h6>
      <div class="col-12 text-normal mb-3">The iSupplier Portal provides PO Collaboration for suppliers supporting
        Onshore and Offshore Wind
        RACES ERP platform. PO Acceptance & promise date management, Serialization Entry, Material Forecasting, Request
        for
        Quotes, and eInvoicing functionality are also available in this application</div>
      <h6 class="col-12 text-normal"><strong>Registration Question</strong></h6>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          User Name
          <span style="color: red;">*
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="userName" name="userName" matInput #userName placeholder="" maxlength="50">
          <mat-hint align="end">{{userName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Email address
          <span style="color: red;">*
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="email" name="email" matInput #email placeholder="" maxlength="50">
          <mat-hint align="end">{{email.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          <span>
            First Name
            <span style="color: red;">*</span>
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="firstName" name="firstName" matInput #firstName placeholder="" maxlength="50">
          <mat-hint align="end">{{firstName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Last Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="lastName" name="lastName" matInput #lastName placeholder="" maxlength="50">
          <mat-hint align="end">{{lastName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Vendor Company Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="companyName" name="companyName" matInput #companyName placeholder="" maxlength="50">
          <mat-hint align="end">{{companyName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Please provide a recent GE Renewables Purchase Order for validation purposes
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="purchaseOrder" name="purchaseOrder" matInput #purchaseOrder placeholder="" maxlength="50">
          <mat-hint align="end">{{purchaseOrder.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          If you needs access to multiple company POs please list each company name and a valid PO for each
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <textarea formControlName="companyPOs" name="companyPOs" matInput #companyPOs placeholder="" rows="5"
            cols="50" id="companyPOs" maxlength="512">
          </textarea>
          <mat-hint align="end">{{companyPOs.value.length}} / 512</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Parent Company Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="companyParent" name="companyParent" matInput #companyParent placeholder="" maxlength="50">
          <mat-hint align="end">{{companyParent.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          GE Buyer Contact
          <span style="color: red;">*</span>
        </div>
        <div class="col-12 justify-content-center text-normal">
          <mat-form-field floatLabel="never" appearance="outline" class="w-100">
            <input formControlName="buyerContact" name="buyerContact" matInput #buyerContact placeholder="" maxlength="50" readonly>
            <mat-icon matSuffix (click)="searchSSO($event)" style="cursor: pointer;">search</mat-icon>
            <mat-hint align="end">{{buyerContact.value.length}} / 50</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Role
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="role" placeholder="Select a role">
            <mat-option *ngFor="let roleOption of roleList" [value]="roleOption">
              {{roleOption}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal"
        style="font-size: 18px;" (click)="submitiSupplierFormForm()">
          <span>
            Request Access
          </span>
        </button>
      </div>
      <br>
    </form>
  </div>
  <div class="col-sm-12 col-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 16px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 p-0 text-normal">
        GE Renewable Energy Supplier Support (<a href="mailto:GERenEnergy.SupplierSupport@ge.com" style="word-wrap: break-word;" class="text-highlight">~GE Vernova Supplier Support</a>)
      </div>
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
        (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a href="{{item?.requestUrl}}" target="_blank">
              {{item?.number}}
            </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>